//加入购物车
export const cart_join = 'cart_join';

//立即购买
export const cart_buy = 'buy_immediately'

//购物车创建
export const cart_create = 'create';

//购物车更新
export const cart_update = 'update';